app.controller('stateOfHealthGeneralController', ['$scope', '$state', '$mdDialog', '$translate', 'patientModel', 'userModel',
    function ($scope, $state, $mdDialog, $translate, patientModel, userModel) {

        function setData() {
            $scope.patientStateOfHealth = null;
            $scope.currentUserId = userModel.currentUser.id;

            $scope.showOptions = {
                all: false
            };

            $scope.listeners = {};
        }


        function setPermissions() {
        }

        function setListeners() {
            $scope.listeners.onStateOfHealthLoad = function (stateOfHealth) {
                $scope.patientStateOfHealth = stateOfHealth;
            }
        }

        function setActions() {

            $scope.getStateOfHealthData = function() {
                if(!$scope.showOptions.all) {
                    patientModel.getStateOfHealth($state.params.patientId).then($scope.listeners.onStateOfHealthLoad);
                } else {
                    patientModel.getStateOfHealthSummaryWithDeleted($state.params.patientId).then($scope.listeners.onStateOfHealthLoad);
                }
                $scope.showOptions.all = !$scope.showOptions.all;
            }

        }

        function configureInterface() {
        }

        function initialize() {
            $scope.getStateOfHealthData();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
